export interface Logo {
  id: string;
  name: string;
  url: string;
}

export type LogosMap = Record<'FR' | 'DE', Logo[]>;

export const CUSTOMER_LOGOS_PER_COUNTRY: LogosMap = {
  FR: [
    {
      id: 'fr-logo1',
      name: 'Back Market',
      url: '/illustrations/clients/fr/backmarket.png',
    },
    {
      id: 'fr-logo2',
      name: 'MistralAI',
      url: '/illustrations/clients/fr/mistralai.png',
    },
    {
      id: 'fr-logo3',
      name: 'Yuka',
      url: '/illustrations/clients/fr/yuka.png',
    },
    {
      id: 'fr-logo4',
      name: 'AnkorStore',
      url: '/illustrations/clients/fr/ankorstore.png',
    },
    {
      id: 'fr-logo5',
      name: 'Skello',
      url: '/illustrations/clients/fr/skello.png',
    },
  ],
  DE: [
    {
      id: 'de-logo1',
      name: 'Too Good To Go',
      url: '/illustrations/clients/de/toogoodtogo.png',
    },
    {
      id: 'de-logo2',
      name: 'Getir',
      url: '/illustrations/clients/de/getir.png',
    },
    {
      id: 'de-logo3',
      name: 'Finanzfluss',
      url: '/illustrations/clients/de/finanzfluss.png',
    },
    {
      id: 'de-logo4',
      name: 'Hive',
      url: '/illustrations/clients/de/hive.png',
    },
    {
      id: 'de-logo5',
      name: 'Back Market',
      url: '/illustrations/clients/de/backmarket.png',
    },
  ],
};
